"use client";

import { OverviewRoute } from "@/modules/overview/routes/OverviewRoute";

export default function OverviewPage() {
  return <OverviewRoute />;
}
